export const types = {
  ACCOUNT_NOTES_ERROR:
    'common/forms/contactAndAccountNotes/ACCOUNT_NOTES_ERROR',
  ACCOUNT_NOTES_REQUEST:
    'common/forms/contactAndAccountNotes/ACCOUNT_NOTES_REQUEST',
  ACCOUNT_NOTES_SUCCESS:
    'common/forms/contactAndAccountNotes/ACCOUNT_NOTES_SUCCESS',
  RESET_ACCOUNT_NOTES:
    'common/forms/contactAndAccountNotes/RESET_ACCOUNT_NOTES',
  CONTACT_NOTES_ERROR:
    'common/forms/contactAndAccountNotes/CONTACT_NOTES_ERROR',
  CONTACT_NOTES_REQUEST:
    'common/forms/contactAndAccountNotes/CONTACT_NOTES_REQUEST',
  CONTACT_NOTES_SUCCESS:
    'common/forms/contactAndAccountNotes/CONTACT_NOTES_SUCCESS',
  RESET_CONTACT_NOTES:
    'common/forms/contactAndAccountNotes/RESET_CONTACT_NOTES',
};

export const saveAccountNotes = {
  request: ({ accountId, notes }) => {
    return {
      type: types.ACCOUNT_NOTES_REQUEST,
      payload: {
        accountId,
        notes,
      },
    };
  },
  success: () => ({ type: types.ACCOUNT_NOTES_SUCCESS }),
  error: (message) => ({
    type: types.ACCOUNT_NOTES_ERROR,
    payload: { message },
  }),
};

export const resetAccountNotes = () => ({ type: types.RESET_ACCOUNT_NOTES });

export const saveContactNotes = {
  request: ({ contactId, notes }) => {
    return {
      type: types.CONTACT_NOTES_REQUEST,
      payload: {
        contactId,
        notes,
      },
    };
  },
  success: () => ({ type: types.CONTACT_NOTES_SUCCESS }),
  error: (message) => ({
    type: types.CONTACT_NOTES_ERROR,
    payload: { message },
  }),
};

export const resetContactNotes = () => ({ type: types.RESET_CONTACT_NOTES });
